import React from "react";
import { Multiselect } from "multiselect-react-dropdown";
import "./custom-select-dropdown.css";
import Select from "react-select";

const CustomSelectDropdown = ({
  displayValue,
  options = [],
  selectedValues = [],
  onSelect,
  onRemove,
  placeholder = "Select",
  singleSelect = false,
  disable = false,
  style,
  ...rest
}) => {
  const isDisabled = !!disable; // convert your prop

  // ---------- MULTI SELECT: Use existing library ----------
  if (!singleSelect) {
    return (
      <Multiselect
        options={options}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onRemove={onRemove}
        displayValue={displayValue}
        placeholder={placeholder}
        style={style}
        disable={isDisabled}
        disabled={isDisabled}
        {...rest}
      />
    );
  }

  // ---------- SINGLE SELECT: Use React Select ----------

  // Convert options to react-select format
  const parsedOptions = options.map((item) => ({
    ...item,
    label: item[displayValue],
    value: item, // store the whole object
  }));

  // Convert selectedValues[0] for react-select
  const value =
    selectedValues && selectedValues[0]
      ? {
          ...selectedValues[0],
          label: selectedValues[0][displayValue],
          value: selectedValues[0],
        }
      : null;

  // Map react-select onChange back to your old API
  const handleChange = (selected) => {
    if (selected) {
      // simulate: onSelect(list, item)
      onSelect([selected.value], selected.value);
    } else {
      // simulate: onRemove(list)
      onRemove([]);
    }
  };

  return (
    <Select
      options={parsedOptions}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      isMulti={false}
      menuPortalTarget={document.body} // <<--- FIX 1
      isDisabled={isDisabled} // <<--- important
      {...rest}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // <<--- FIX 2
        control: (base) => ({
          ...base,
          backgroundColor: "#f8f8f8",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? "#fbb040" : state.isFocused ? "#fbb040" : "#fff",
          color: state.isFocused || state.isSelected ? "#fff" : "#333",
        }),
      }}
    />
  );
};

export default CustomSelectDropdown;
